export const SNOWFLAKE_NAME = "snowflake";
export const SNOWFLAKE_DISPLAY_NAME = "Snowflake";

export const BASE_URL_PREFIX = `/config/${SNOWFLAKE_NAME}`;
